import script from "./AddCouponReservationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCouponReservationForm.vue?vue&type=script&setup=true&lang=js"

import "./AddCouponReservationForm.vue?vue&type=style&index=0&id=1288fc40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1288fc40"]])

export default __exports__